// Which browser we are in, to the extent it changes what we must tell the member.
//
// Only used for copy and capability hints — never for privilege. UA strings lie.
//
// P2 (PWA install screen) needs the same distinctions; import from here rather
// than writing a second copy.

function ua() {
  if (typeof navigator === 'undefined') return '';
  return navigator.userAgent || '';
}

// WhatsApp, Instagram, Facebook, Telegram, Line and the Google app all render
// pages in a webview that cannot install a PWA and, on iOS, often cannot hold a
// camera permission either.
export function isInAppBrowser() {
  return /FBAN|FBAV|Instagram|WhatsApp|Line\/|Telegram|GSA\/|; wv\)/i.test(ua());
}

export function isIos() {
  const agent = ua();
  if (/iPad|iPhone|iPod/.test(agent)) return true;
  // iPadOS 13+ reports itself as a Mac; the touch points give it away.
  return /Macintosh/.test(agent)
    && typeof navigator !== 'undefined'
    && navigator.maxTouchPoints > 1;
}

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  const displayMode = window.matchMedia?.('(display-mode: standalone)')?.matches;
  return Boolean(displayMode || window.navigator?.standalone);
}

/**
 * 'ios-safari' | 'android-chromium' | 'desktop-chromium' | 'in-app-browser' | 'other'
 */
export function platform() {
  if (isInAppBrowser()) return 'in-app-browser';
  if (isIos()) return 'ios-safari';
  const agent = ua();
  const chromium = /Chrome|Chromium|CriOS|Edg/.test(agent);
  if (/Android/.test(agent)) return chromium ? 'android-chromium' : 'other';
  if (chromium) return 'desktop-chromium';
  return 'other';
}
